import { useCallback } from 'react'

import cn from 'classnames'
import { debounce } from 'lodash'

import SearchIcon from '@src/components/icons/Search'

type SearchInputProps = {
    onValueChange?: React.Dispatch<string>
} & React.InputHTMLAttributes<HTMLInputElement>

const SearchTokenInput: React.FC<SearchInputProps> = ({ onValueChange, className, ...props }: SearchInputProps) => {
    const debounceChangeHandler = useCallback(
        debounce((e: React.ChangeEvent<HTMLInputElement>) => onValueChange && onValueChange(e.target?.value), 300),
        [onValueChange, debounce]
    )

    return (
        <div
            className={cn(
                'flex items-center space-x-3 rounded-lg bg-[#141618] px-4 py-3 ring-1 ring-gray-700/50',
                className
            )}
        >
            <SearchIcon className='h-4 w-4 text-gray-400' />
            <input
                {...props}
                className='w-full bg-transparent text-sm text-white placeholder-gray-400 outline-none'
                placeholder='Search by transaction hash or address'
                onChange={debounceChangeHandler}
            />
        </div>
    )
}

export default SearchTokenInput
